module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/alert/error-modal.component.css
// module id = ./src/app/alert/error-modal.component.css
// module chunks = main